/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";

import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {SignInButton} from "./SignInButton";
import {Nav} from "react-bootstrap";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Box, Heading} from "grommet";

/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = ({onClick, ...props}) => {
    const isAuthenticated = useIsAuthenticated();
    const {accounts} = useMsal();
    const location = useLocation();
    const navigate = useNavigate();

    let style;
    if (isAuthenticated) {
        style = {};
    } else {
        style = {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed"
        }
    }

    let navigation = [
        {
            label: "Review billable",
            link: "/"
        },
        {
            label: "Billing summary",
            link: "/billablesummary"
        },
        {
            label: "Engineering",
            link: "/engineering"
        },
        {
            label: "Invoices",
            link: "/invoices"
        },
    ]

    return (
        <>
            <Box direction={"row"} style={{paddingLeft: "1em", background: "#1c243b", color: "#fff"}} pad={"medium"}
                 align={"center"}
                 gap={"medium"}>
                <Box><Heading level={"3"}>Timereporting Sync</Heading></Box>
                <Box direction={"row"} justify={"between"} flex={"grow"} style={{fontSize: "110%", fontWeight: "bold"}}>
                    <Box direction={"row"} gap={"medium"}>
                        {navigation.map(n =>
                            (
                                <Box key={n.link} style={{color: "#fff", borderRadius: "20px"}}
                                     focusIndicator={false}
                                     pad={{horizontal: "medium", vertical: "xsmall"}}
                                     background={location.pathname === n.link ? "#ffffff2a" : "transparent"}
                                     onClick={() => navigate(n.link)}>
                                    {n.label}
                                </Box>

                            )
                        )}
                    </Box>
                    <Box pad={"xsmall"}>{accounts?.[0]?.name}</Box>
                </Box>
            </Box>

            <div style={style}>
                <div>
                    {!isAuthenticated && <SignInButton/>}
                </div>
            </div>
            {isAuthenticated && <Outlet/>}
        </>
    );
};